import {
  FETCH_COMBINED_STATS,
  FETCH_ENGAGEMENT_STATS,
  FETCH_RECENT_USERS,
  FETCH_SINGLE_USER_ACTIONS,
  FETCH_USAGE_DATA,
  receiveCombinedStats,
  receiveEngagementStats,
  receiveRecentUsers,
  receiveSingleUserActions,
  receiveUsageData,
} from "@/components/activity/admin/ducks/Actions"
import {
  apiFetchCombinedStats,
  apiFetchRecentUsers,
  apiFetchSingleUserActions,
  apiFetchUsageData,
  apiGetEngagementStats,
} from "@/components/activity/admin/ducks/AJAX"

export default (store) => (next) => (action) => {
  switch (action.type) {
    case FETCH_USAGE_DATA:
      apiFetchUsageData(
        action.page,
        store.getState().activity.admin.userActionsFilter,
        receiveUsageData,
        null,
      )
      return next(action)

    case FETCH_RECENT_USERS:
      apiFetchRecentUsers(action.page, receiveRecentUsers, null)
      return next(action)

    case FETCH_SINGLE_USER_ACTIONS:
      apiFetchSingleUserActions(
        action.userId,
        action.page,
        action.recordType,
        store.getState().activity.admin.getByAgent,
        receiveSingleUserActions,
        action.error,
      )
      return next(action)

    case FETCH_COMBINED_STATS:
      apiFetchCombinedStats(receiveCombinedStats, null)
      return next(action)

    case FETCH_ENGAGEMENT_STATS:
      apiGetEngagementStats(receiveEngagementStats, action.error)
      return next(action)

    default:
      return next(action)
  }
}
